import React from 'react';
import { Markup } from 'interweave';
import I18n from 'utils/I18n';
import PropTypes from 'prop-types';

import styles from './index.scss';

const DisclaimerText = ({ showLoginOption }) => {
  const I18nPrefix = 'strava.landing_page';

  const legalTerms = I18n.t(
    `${I18nPrefix}.disclaimer_text.by_clicking_cta_html`,
    {
      terms_path: '/legal/terms'
    }
  );

  const legalPrivacy = I18n.t(
    `${I18nPrefix}.disclaimer_text.view_privacy_policy_html`,
    {
      privacy_path: '/legal/privacy'
    }
  );

  return (
    <div className={styles.disclaimerText}>
      <p>
        <Markup noWrap={true} content={legalTerms} />{' '}
        <Markup noWrap={true} content={legalPrivacy} />
      </p>
      {showLoginOption && (
        <p>
          {I18n.t(`${I18nPrefix}.already_a_member`)}{' '}
          <a href="/login"> {I18n.t(`${I18nPrefix}.log_in`)}</a>
        </p>
      )}
    </div>
  );
};

DisclaimerText.propTypes = {
  showLoginOption: PropTypes.bool
};

DisclaimerText.defaultProps = {
  showLoginOption: true
};

export default DisclaimerText;
